/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The reducer component for widgets
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    LOAD_WIDGET_META,
    LOAD_WIDGET_META_FAILED,
    LOAD_WIDGET_META_SUCCESSFUL,
} from './constants/widgetActionConstants';
import { IWidgetReducerState, TWidgetActionsType } from './widgetTypes';

export const widgetInitialState: IWidgetReducerState = {
    emptyWidgets: false,
    error: '',
    widgetMeta: [],
};

const widgetReducer: Reducer<IWidgetReducerState, TWidgetActionsType> =
    (state = widgetInitialState, action: TWidgetActionsType) =>
        produce(state, draft => {
            switch (action.type) {
                case LOAD_WIDGET_META:
                    break;
                case LOAD_WIDGET_META_SUCCESSFUL:
                    draft.widgetMeta = action.payload;
                    draft.emptyWidgets = action.payload.length === 0;
                    break;
                case LOAD_WIDGET_META_FAILED:
                    draft.error = action.payload;
                    draft.emptyWidgets = true;
                    break;
                default:
                    break;
            }
        });

export default widgetReducer;
